module.exports = __webpack_public_path__ + "img/Garborg_En_intellektuell_forfatter.a04ce489.jpg";